import * as React from "react";
import {} from "@blueprintjs/core";
import { FGSelectInput, IFGSelectInputProps } from "nsitools-react";
import { useCommonHooks } from "../../hooks";
import { useGenderRef } from "../../hooks/applicationHooks/useGenderRef";

import { ReferentialItemDto } from "../../api";
import { nameof } from "../../utils";

export interface GenderSelectProps
  extends Pick<
    IFGSelectInputProps<any>,
    "requiredMark" | "visible" | "disabled" | "style" | "readonly"
  > {
  name: string;
  label?: string;
  loading?: boolean;
}

export const GenderSelect: React.FunctionComponent<GenderSelectProps> = ({
  name,
  label,
  loading = false,
  ...fgSelectInputProps
}) => {
  const { t } = useCommonHooks();
  const { genders, gendersLoading } = useGenderRef();

  return (
    <FGSelectInput
      label={label || t("Gender")}
      name={name}
      items={genders}
      loading={gendersLoading || loading}
      displayField={nameof<ReferentialItemDto>("displayValue")}
      valueField={nameof<ReferentialItemDto>("idValue")}
      isFilterable={true}
      {...fgSelectInputProps}
    />
  );
};

export default GenderSelect;
